import React, { useEffect, useState } from "react";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { ReactComponent as Bloqueado } from "../../assets/newImages/icons/bloqueado.svg";
import { ReactComponent as Liberado } from "../../assets/newImages/icons/liberado.svg";
import { ReactComponent as SetaEsquerda } from "../../assets/newImages/icons/arrow-left.svg";
import { ReactComponent as SetaDireita } from "../../assets/newImages/icons/arrow-right.svg";
import { ReactComponent as ArrowUp } from "../../assets/newImages/icons/arrow-up.svg";
import { Button } from "../../components/Button";
import {
  Texto,
  Periodicidade,
  ComparativoPermissoes,
  ComparativoPermissoesMobile,
  ScrollToTopButton,
} from "./style";
import { EmpresaApi } from "../../hooks/empresaApi";

const PERMISSOES = {
  Básico: [
    // Seção: Atendimento e conhecimento
    {
      permissao: "Gerente da conta",
      informacao: <Bloqueado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "WhatsApp",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Chat no painel administrativo",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Telefone",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Clube Conectado",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Mentoria de Implementação",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    // Seção: Usuários e produtos
    {
      permissao: "Usuários",
      informacao: <div className="permissao">1 usuário</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Permissões dos usuários",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Produtos",
      informacao: <div className="permissao">99</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Descrição com IA",
      informacao: <div className="permissao">50 000 tokens</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Observação para personalizados",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Variações",
      informacao: <div className="permissao">5 variações</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "2 níveis de variações",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Categorias",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Imagens",
      informacao: <div className="permissao">1 por produto</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Vídeo",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Controle de estoque",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tag de destaque",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tabelas de preço",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Quantidade mínima de compra",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Multiplicador",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Importação em massa",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Agendar publicação do produto",
      informacao: <Bloqueado />,
      secao: "Usuários e produtos",
    },
    // Seção: Catalogo e personalização
    {
      permissao: "Catálogos",
      informacao: <div className="permissao">3 catálogos</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Personalização de cores",
      informacao: <div className="permissao">2 cores</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Banner",
      informacao: <div className="permissao">1 banner</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Replicar catálogos",
      informacao: <Bloqueado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Agendar expiração",
      informacao: <Bloqueado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Manutenção do catálogo",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    // Seção: Recursos gerais
    {
      permissao: "Pedidos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Visitas",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Relatórios",
      informacao: <div className="permissao">Produtos, clientes e pedidos</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Métricas",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Captura de lead",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Subdomínio",
      informacao: <Bloqueado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Domínio",
      informacao: <Bloqueado />,
      secao: "Recursos gerais",
    },
    // Seção: Pagamento
    {
      permissao: "Taxa sobre as vendas",
      informacao: <div className="permissao">0%</div>,
      secao: "Pagamento",
    },
    { permissao: "À combinar", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "Pix", informacao: <Bloqueado />, secao: "Pagamento" },
    {
      permissao: "Cartão de crédito",
      informacao: <Bloqueado />,
      secao: "Pagamento",
    },
    {
      permissao: "Checkout transparente",
      informacao: <Bloqueado />,
      secao: "Pagamento",
    },
    { permissao: "Stone", informacao: <Bloqueado />, secao: "Pagamento" },
    { permissao: "PagBank", informacao: <Bloqueado />, secao: "Pagamento" },
    {
      permissao: "Mercado Pago",
      informacao: <Bloqueado />,
      secao: "Pagamento",
    },
    // Seção: Entrega e retirada
    {
      permissao: "Entrega local",
      informacao: <Bloqueado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Entrega especial",
      informacao: <Bloqueado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Retirada local",
      informacao: <Bloqueado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Melhor Envio",
      informacao: <Bloqueado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Correios",
      informacao: <Bloqueado />,
      secao: "Entrega e retirada",
    },
    // Seção: Marketing e promoções
    {
      permissao: "Cupom de desconto",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Frete grátis",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Ajuste de preço De: / Por:",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Mínimo de compra por valor ou produtos",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolas abandonadas",
      informacao: <div className="permissao">Histórico de 30 dias</div>,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolinha do Instagram",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Desconto progressivo",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    // Seção: Integrações
    { permissao: "Tiny", informacao: <Bloqueado />, secao: "Integrações" },
    { permissao: "Bling", informacao: <Bloqueado />, secao: "Integrações" },
    {
      permissao: "Chave de API",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Pixel e API do Facebook",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Pinterest Ads",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Google Analytics",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Google TagManager",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
  ],

  Essencial: [
    // Seção: Atendimento e conhecimento
    {
      permissao: "Gerente da conta",
      informacao: <Bloqueado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "WhatsApp",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Chat no painel administrativo",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Telefone",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Clube Conectado",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Mentoria de Implementação",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    // Seção: Usuários e produtos
    {
      permissao: "Usuários",
      informacao: <div className="permissao">2 usuários</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Permissões dos usuários",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Produtos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Descrição com IA",
      informacao: <div className="permissao">200 000 tokens</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Observação para personalizados",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Variações",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "2 níveis de variações",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Categorias",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Imagens",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Vídeo",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Controle de estoque",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tag de destaque",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tabelas de preço",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Quantidade mínima de compra",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Multiplicador",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Importação em massa",
      informacao: <div className="permissao">Planilha csv</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Agendar publicação do produto",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    // Seção: Catalogo e personalização
    {
      permissao: "Catálogos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Personalização de cores",
      informacao: <div className="permissao">2 cores</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Banner",
      informacao: <div className="permissao">Carrossel com 3 banners</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Replicar catálogos",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Agendar expiração",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Manutenção do catálogo",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    // Seção: Recursos gerais
    {
      permissao: "Pedidos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Visitas",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Relatórios",
      informacao: <div className="permissao">Produtos, clientes e pedidos</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Métricas",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Captura de lead",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Subdomínio",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Domínio",
      informacao: <Bloqueado />,
      secao: "Recursos gerais",
    },
    // Seção: Pagamento
    {
      permissao: "Taxa sobre as vendas",
      informacao: <div className="permissao">0%</div>,
      secao: "Pagamento",
    },
    { permissao: "À combinar", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "Pix", informacao: <Liberado />, secao: "Pagamento" },
    {
      permissao: "Cartão de crédito",
      informacao: <Liberado />,
      secao: "Pagamento",
    },
    {
      permissao: "Checkout transparente",
      informacao: <Liberado />,
      secao: "Pagamento",
    },
    { permissao: "Stone", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "PagBank", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "Mercado Pago", informacao: <Liberado />, secao: "Pagamento" },
    // Seção: Entrega e retirada
    {
      permissao: "Entrega local",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Entrega especial",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Retirada local",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Melhor Envio",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Correios",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    // Seção: Marketing e promoções
    {
      permissao: "Cupom de desconto",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Frete grátis",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Ajuste de preço De: / Por:",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Mínimo de compra por valor ou produtos",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolas abandonadas",
      informacao: <div className="permissao">Histórico de 30 dias</div>,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolinha do Instagram",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Desconto progressivo",
      informacao: <Bloqueado />,
      secao: "Marketing e promoções",
    },
    // Seção: Integrações
    { permissao: "Tiny", informacao: <Liberado />, secao: "Integrações" },
    { permissao: "Bling", informacao: <Liberado />, secao: "Integrações" },
    {
      permissao: "Chave de API",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Pixel e API do Facebook",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Pinterest Ads",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Google Analytics",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
    {
      permissao: "Google TagManager",
      informacao: <Bloqueado />,
      secao: "Integrações",
    },
  ],

  Avançado: [
    // Seção: Atendimento e conhecimento
    {
      permissao: "Gerente da conta",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "WhatsApp",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Chat no painel administrativo",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Telefone",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Clube Conectado",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    {
      permissao: "Mentoria de Implementação",
      informacao: <Liberado />,
      secao: "Atendimento e conhecimento",
    },
    // Seção: Usuários e produtos
    {
      permissao: "Usuários",
      informacao: <div className="permissao">4 usuários</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Permissões dos usuários",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Produtos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Descrição com IA",
      informacao: <div className="permissao">500 000 tokens</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Observação para personalizados",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Variações",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "2 níveis de variações",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Categorias",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Imagens",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Vídeo",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Controle de estoque",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tag de destaque",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Tabelas de preço",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Quantidade mínima de compra",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Multiplicador",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Importação em massa",
      informacao: <div className="permissao">Planilha csv</div>,
      secao: "Usuários e produtos",
    },
    {
      permissao: "Agendar publicação do produto",
      informacao: <Liberado />,
      secao: "Usuários e produtos",
    },
    // Seção: Catalogo e personalização
    {
      permissao: "Catálogos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Personalização de cores",
      informacao: <div className="permissao">2 cores</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Banner",
      informacao: <div className="permissao">Carrossel com 3 banners</div>,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Replicar catálogos",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Agendar expiração",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    {
      permissao: "Manutenção do catálogo",
      informacao: <Liberado />,
      secao: "Catálogo e personalização",
    },
    // Seção: Recursos gerais
    {
      permissao: "Pedidos",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Visitas",
      informacao: <div className="permissao">Ilimitado</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Relatórios",
      informacao: <div className="permissao">Produtos, clientes, pedidos e personalizados</div>,
      secao: "Recursos gerais",
    },
    {
      permissao: "Métricas",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Captura de lead",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Subdomínio",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    {
      permissao: "Domínio",
      informacao: <Liberado />,
      secao: "Recursos gerais",
    },
    // Seção: Pagamento
    {
      permissao: "Taxa sobre as vendas",
      informacao: <div className="permissao">0%</div>,
      secao: "Pagamento",
    },
    { permissao: "À combinar", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "Pix", informacao: <Liberado />, secao: "Pagamento" },
    {
      permissao: "Cartão de crédito",
      informacao: <Liberado />,
      secao: "Pagamento",
    },
    {
      permissao: "Checkout transparente",
      informacao: <Liberado />,
      secao: "Pagamento",
    },
    { permissao: "Stone", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "PagBank", informacao: <Liberado />, secao: "Pagamento" },
    { permissao: "Mercado Pago", informacao: <Liberado />, secao: "Pagamento" },
    // Seção: Entrega e retirada
    {
      permissao: "Entrega local",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Entrega especial",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Retirada local",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Melhor Envio",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    {
      permissao: "Correios",
      informacao: <Liberado />,
      secao: "Entrega e retirada",
    },
    // Seção: Marketing e promoções
    {
      permissao: "Cupom de desconto",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Frete grátis",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Ajuste de preço De: / Por:",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Mínimo de compra por valor ou produtos",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolas abandonadas",
      informacao: <div className="permissao">Histórico de 30 dias</div>,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Sacolinha do Instagram",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    {
      permissao: "Desconto progressivo",
      informacao: <Liberado />,
      secao: "Marketing e promoções",
    },
    // Seção: Integrações
    { permissao: "Tiny", informacao: <Liberado />, secao: "Integrações" },
    { permissao: "Bling", informacao: <Liberado />, secao: "Integrações" },
    {
      permissao: "Chave de API",
      informacao: <Liberado />,
      secao: "Integrações",
    },
    {
      permissao: "Pixel e API do Facebook",
      informacao: <Liberado />,
      secao: "Integrações",
    },
    {
      permissao: "Pinterest Ads",
      informacao: <Liberado />,
      secao: "Integrações",
    },
    {
      permissao: "Google Analytics",
      informacao: <Liberado />,
      secao: "Integrações",
    },
    {
      permissao: "Google TagManager",
      informacao: <Liberado />,
      secao: "Integrações",
    },
  ],
};

// Dados dos planos organizados
const PLANOS = [
  {
    nome: "Básico",
    periodicidade: "Mensal",
    descricao:
      "A opção perfeita para quem está iniciando na venda online e precisa captar leads e receber seus pedidos de forma organizada.",
    valor: "67,90",
    equivalente: "Equivalente a R$ 2,63/dia",
  },
  {
    nome: "Essencial",
    periodicidade: "Mensal",
    descricao:
      "A melhor escolha para quem está iniciando a venda online, com recursos de pagamento e frete para automatizar a operação.",
    valor: "157,90",
    equivalente: "Equivalente a R$ 5,26/dia",
  },
  {
    nome: "Avançado",
    periodicidade: "Mensal",
    descricao:
      "Ideal para empresas que possuem grandes demandas em vendas e precisam de recursos avançados de gestão, vendas e tráfego pago.",
    valor: "259,90",
    equivalente: "Equivalente a R$ 8,66/dia",
  },
  {
    nome: "Básico",
    periodicidade: "Anual",
    descricao:
      "A opção perfeita para quem está iniciando na venda online e precisa captar leads e receber seus pedidos de forma organizada.",
    desconto: "15%",
    valor: "57,71",
    valorRiscado: "R$ 67,90",
    equivalente: "Total ano: R$ 692,58 em até 12x",
  },
  {
    nome: "Essencial",
    periodicidade: "Anual",
    descricao:
      "A melhor escolha para quem está iniciando a venda online, com recursos de pagamento e frete para automatizar a operação.",
    desconto: "20%",
    valor: "126,32",
    valorRiscado: "R$ 157,90",
    equivalente: "Total ano: R$ 1.515,84 em até 12x",
  },
  {
    nome: "Avançado",
    periodicidade: "Anual",
    descricao:
      "Ideal para empresas que possuem grandes demandas em vendas e precisam de recursos avançados de gestão, vendas e tráfego pago.",
    desconto: "25%",
    valor: "194,92",
    valorRiscado: "R$ 259,90",
    equivalente: "Total ano: R$ 2.339,10 em até 12x",
  },
];

// Adicione esta função auxiliar antes do componente Planos
const isPlanoBaixoOuIgual = (planoAtual: string, planoComparado: string) => {
  const ordem = ["Básico", "Essencial", "Avançado"];
  const indexAtual = ordem.indexOf(planoAtual);
  const indexComparado = ordem.indexOf(planoComparado);
  
  // Retorna true se o plano comparado for igual ou inferior ao plano atual
  return indexComparado <= indexAtual;
};

export const Planos: React.FC = () => {
  const { theme } = useTheme();
  const [periodicidadeSelecionada, setPeriodicidadeSelecionada] =
    useState("Anual");
  const [planoSelecionado, setPlanoSelecionado] = useState(0); // Índice do plano selecionado
  const planosFiltrados = PLANOS.filter(
    (plano) => plano.periodicidade === periodicidadeSelecionada
  );
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [nomePlano, setNomePlano] = useState("");

  const handleNext = () => {
    setPlanoSelecionado((prev) => (prev + 1) % planosFiltrados.length);
  };

  const handlePrev = () => {
    setPlanoSelecionado(
      (prev) => (prev - 1 + planosFiltrados.length) % planosFiltrados.length
    );
  };

  const planoAtual = planosFiltrados[planoSelecionado];

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    EmpresaApi()
      .plano_empresa()
      .then((res) => {
        setNomePlano(res.nome_plano);
        console.log(res.nome_plano);
      });
  }, []);

  return (
    <div className="view-plan">
      <Texto theme={theme}>
        Quer migrar entre os planos? Escolha abaixo a periodicidade desejada e
        selecione seu plano.
      </Texto>

      {/* Seletor de periodicidade */}
      <Periodicidade theme={theme}>
        {["Mensal", "Anual"].map((nome, index) => (
          <div
            key={index}
            className={`fonteTexto opcao ${
              nome === periodicidadeSelecionada ? "selecionado" : ""
            }`}
            onClick={() => setPeriodicidadeSelecionada(nome)}
          >
            {nome}
            {nome === "Anual" && <span className="fonteRotulos"> Até 25% OFF</span>}
          </div>
        ))}
      </Periodicidade>

      {/* Comparativo de permissões */}
      <ComparativoPermissoes theme={theme}>
        <table className="hideMobile">
          <thead>
            <tr className="cabecalho-planos">
              <th className="recursos fonteTitulo">Recursos</th>
              {PLANOS.filter(
                (plano) => plano.periodicidade === periodicidadeSelecionada
              ).map((plano, index) => (
                <th key={index} className={nomePlano === plano.nome ? "plano-atual-col" : ""}>
                  <div className={nomePlano === plano.nome ? "plano-atual" : ""}>
                    <div className="titulo">
                      <div className="nome fonteTitulo">{plano.nome}</div>
                      {plano.desconto && (
                        <div className="desconto fonteRotulos">{plano.desconto} OFF</div>
                      )}
                    </div>
                    <div className="descricao fonteTexto">
                      <span>{plano.descricao}</span>
                    </div>
                    {plano.valorRiscado && (
                      <div className="valor-riscado fonteRotulos">{plano.valorRiscado}</div>
                    )}
                    <div className="valor fonteTexto">
                      R$ <span className="fonteTitulo">{plano.valor}</span>/ao mês
                    </div>
                    <div className="equivalente fonteRotulos">{plano.equivalente}</div>
                    
                    {/* Mostrar botão apenas se o plano for superior ao atual */}
                    {!isPlanoBaixoOuIgual(nomePlano, plano.nome) && (
                      <a
                        href={`https://api.whatsapp.com/send?phone=555434434563&text=Olá,%20gostaria%20de%20mudar%20meu%20plano%20para%20${plano.nome}%20na%20periodicidade%20${periodicidadeSelecionada}`}
                        target="_blank"
                      >
                        <Button title="Quero esse plano" width="100%" />
                      </a>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {/* Agrupando permissões por seção */}
            {[
              "Atendimento e conhecimento",
              "Usuários e produtos",
              "Catálogo e personalização",
              "Recursos gerais",
              "Pagamento",
              "Entrega e retirada",
              "Marketing e promoções",
              "Integrações",
            ].map((secao, secaoIndex) => (
              <React.Fragment key={secaoIndex}>
                {/* Linha da seção */}
                <tr className="secao fonteSubtitulo">
                  <td
                    colSpan={
                      PLANOS.filter(
                        (plano) =>
                          plano.periodicidade === periodicidadeSelecionada
                      ).length + 1
                    }
                  >
                    {secao}
                  </td>
                </tr>
                {/* Linhas das permissões */}
                {PERMISSOES["Básico"]
                  .filter((item) => item.secao === secao)
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="recurso fonteTexto">{item.permissao}</td>
                      {PLANOS.filter(
                        (plano) =>
                          plano.periodicidade === periodicidadeSelecionada
                      ).map((plano, planoIndex) => (
                        <td 
                          key={planoIndex} 
                          className={`informacao fonteTexto ${nomePlano === plano.nome ? "plano-atual-cell" : ""}`}
                        >
                          {PERMISSOES[plano.nome]?.find(
                            (p) => p.permissao === item.permissao
                          )?.informacao || "❌"}
                        </td>
                      ))}
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </ComparativoPermissoes>

      <ComparativoPermissoesMobile theme={theme}>
        <div className="plano-atual hideDesktop">
          <div className="cabecalho">
            <button onClick={handlePrev} className="seta-esquerda">
              <SetaEsquerda />
            </button>
            <div className={`informacoes-plano ${nomePlano === planoAtual.nome ? 'seu-plano-atual' : ''}`}>
              <div className="titulo">
                <div className="nome">{planoAtual.nome}</div>
                {planoAtual.desconto && (
                  <div className="desconto">{planoAtual.desconto} OFF</div>
                )}
              </div>
              <div className="descricao">
                <span>{planoAtual.descricao}</span>
              </div>
              {planoAtual.valorRiscado && (
                <div className="valor-riscado">{planoAtual.valorRiscado}</div>
              )}
              <div className="valor">
                R$ <span>{planoAtual.valor}</span>/ao mês
              </div>
              <div className="equivalente">{planoAtual.equivalente}</div>
              
              {/* Mostrar botão apenas se o plano for superior ao atual */}
              {!isPlanoBaixoOuIgual(nomePlano, planoAtual.nome) && (
                <a
                  href={`https://api.whatsapp.com/send?phone=555434434563&text=Olá,%20gostaria%20de%20mudar%20meu%20plano%20para%20${planoAtual.nome}%20na%20periodicidade%20${periodicidadeSelecionada}`}
                  target="_blank"
                  style={{ marginTop: '2rem', display: 'block' }}
                >
                  <Button title="Quero esse plano" width="100%" />
                </a>
              )}
            </div>
            <button onClick={handleNext} className="seta-direita">
              <SetaDireita />
            </button>
          </div>
          
          {[
            "Atendimento e conhecimento",
            "Usuários e produtos",
            "Catálogo e personalização",
            "Recursos gerais",
            "Pagamento",
            "Entrega e retirada",
            "Marketing e promoções",
            "Integrações",
          ].map((secao, secaoIndex) => (
            <div 
              key={secaoIndex} 
              className={`secao-permissoes ${nomePlano === planoAtual.nome ? 'seu-plano-atual' : ''}`}
            >
              <div className="titulo-secao">{secao}</div>
              {PERMISSOES[planoAtual.nome]
                ?.filter((item) => item.secao === secao)
                .map((item, index) => (
                  <div key={index} className="lista-permissoes">
                    <div className="titulo">{item.permissao}</div>
                    <div className="informacao">{item.informacao}</div>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </ComparativoPermissoesMobile>

      {showScrollButton && (
        <ScrollToTopButton onClick={scrollTop} theme={theme}>
          <ArrowUp />
        </ScrollToTopButton>
      )}
    </div>
  );
};

export default Planos;
